<div class="containerDiv flex flex-col gap-1.5">
  <ion-button expand="block" (click)="selectOption(false)">
    <div class="w-100 flex flex-row items-center justify-center gap-1.5">
      <div class="flex flex-col items-center justify-center gap-1.5">
        <div class="w-100">
          <span class="title">Individual</span>
        </div>
        <div class="sub-title w-100">
          <span>Por separado </span>
        </div>
      </div>
    </div>
  </ion-button>
  <ion-button expand="block" (click)="selectOption(true)" [disabled]="isGroupedDisabled()">
    <div class="w-100 flex flex-row items-center justify-center gap-1.5">
      <div class="flex flex-col items-center justify-center gap-1.5">
        <div class="w-100">
          <span class="title">Agrupado</span>
        </div>
        <div class="sub-title w-100">
          <span>Todo junto </span>
        </div>
      </div>
    </div>
  </ion-button>
</div>
